import { Action } from "./Action.js";
import { toBool, getElementByIdInContext } from "../lib/utils.js";
/**
 * @class OpenUrl
 * @extends Action
 * @classdesc Действие Открыть адрес
 * Открыть любой адрес
 * */
export class OpenUrl extends Action {
    execute() {
        let address = this.Address;
        if (this.parameters) {
            address = this.addParameters(address);
        }

        if (this.AddSessionId) {
            address = `${address}${address.indexOf("?") !== -1 ? "&" : "?"
                }session_id=${$sw.sessionId}`;
        }

        if (this._openNew === true) {
            window.open(address, "_blank");
        } else {
            if (this._FrameID) {
                // поскольку на странице могут быть несколько экземпляторов объектов,
                // то у них будут одинаковые id, поэтому нужно искать нужный объект внутри текущего контекста:
                const frame = this.FrameID
                    ? getElementByIdInContext(this.context, this.FrameID)
                    : document.querySelector("ms-frame");
                const isExternalAddress = address.indexOf('//') !== -1;
                frame.datasource = $sw.serverState.haveReserv && !isExternalAddress && address
                    ? `${window.location.protocol}//${$sw.serverState.location.hostname}:${$sw.serverState.location.port}/${address}`
                    : address;
            } else {
                window.open(address, "_self");
            }
        }
    }

    addParameters(address) {
        return Object.entries(this.parameters)
            .sort() // нужно сгруппировать по именам, поскольку ключ-значение могут приходить в разном порядке, т.е. в перемешку
            .map((x, i, arr) => (i % 2 === 0 ? arr[i + 1] : arr[i - 1])) // нужно, чтобы сначала шёл TargetName, а затем Source
            .reduce((acc, [, next]) => {
                switch (acc.slice(-1)) {
                    case "?": {
                        return `${acc}${next}=`;
                    }
                    case "=": {
                        return `${acc}${next}`;
                    }
                    default: {
                        return `${acc}&${next}=`;
                    }
                }
            }, `${address}${address.indexOf("?") !== -1 ? "" : "?"}`);
    }

    get Address() {
        return this._address || "";
    }
    set Address(v) {
        this._address = v;
    }

    get OpenNew() {
        return typeof this._openNew === "boolean" ? this._openNew : false;
    }
    set OpenNew(v) {
        this._openNew = toBool(v);
    }

    get AddSessionId() {
        return this._addSessionId;
    }
    set AddSessionId(v) {
        this._addSessionId = v;
    }

    get FrameID() {
        return typeof this._FrameID === "undefined" ? "" : this._FrameID;
    }
    set FrameID(value) {
        if (value.toString().includes(".")) {
            this._FrameID = $pr.getWindowIdByPath(value);
        } else {
            this._FrameID = value;
        }
    }
}
